
// export const url: string = 'https://www.matchabout.com/soa-1/services';
// export const base: string = 'https://www.matchabout.com/';

export const url: string = 'https://dev.matchabout.com/soa-1/services';
export const base: string = 'https://dev.matchabout.com/';

// export const url: string = 'https://dev.matchabout.com/soa-1/services';
// export const base: string = 'https://dev.matchabout.com/';
// export const url: string = 'http://192.168.0.114:8080/soa-1/services';
// export const base: string = 'http://192.168.0.114:8080/';



// WEBPACK FOOTER //
// ./src/assets/global.ts